import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    width: '100%',
    height: 'auto',
    '& p': {
      margin: 0,
    },
    '& input[type=number]': {
      '-moz-appearance': 'textfield',

    },
    '& input::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  formOverall: {
    marginTop: '27px',
  },
  formNote: {
    marginTop: '31px',
    marginBottom: '31px',
    marginLeft: '25px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '8px',
      marginRight: '8px',
    },
    '& p:nth-of-type(1)': {
      fontSize: '18px',
      lineHeight: '26px',
      fontWeight: 400,
      [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
        lineHeight: '23px',
      },
    },
    '& p:nth-of-type(2)': {
      fontSize: '15px',
      lineHeight: '23px',
      fontWeight: 400,
      color: '#6F7878',
      [theme.breakpoints.down('sm')]: {
        fontSize: '13px',
        lineHeight: '20px',
      },
    },
  },

  formNoteImportant: {
    color: '#CD0021',
  },

}));

export default useStyles;
